import { default as complaintsoDzSBusztaMeta } from "/opt/buildhome/repo/pages/complaints.vue?macro=true";
import { default as delivery_45paymentzgElIuRkhDMeta } from "/opt/buildhome/repo/pages/delivery-payment.vue?macro=true";
import { default as gdprUn6LeV527aMeta } from "/opt/buildhome/repo/pages/gdpr.vue?macro=true";
import { default as indexXnjAFlSI44Meta } from "/opt/buildhome/repo/pages/gift-cards/cs/index.vue?macro=true";
import { default as returnpWv5oweWm0Meta } from "/opt/buildhome/repo/pages/gift-cards/cs/return.vue?macro=true";
import { default as index1sUdsfUV9eMeta } from "/opt/buildhome/repo/pages/gift-cards/en/index.vue?macro=true";
import { default as returng9u9SuB867Meta } from "/opt/buildhome/repo/pages/gift-cards/en/return.vue?macro=true";
import { default as indexniDiYCWjuTMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as maintenancefe5TKEsKxKMeta } from "/opt/buildhome/repo/pages/maintenance.vue?macro=true";
import { default as nusleWL9GlWVBSGMeta } from "/opt/buildhome/repo/pages/nusle.vue?macro=true";
import { default as sluzbyHr7Wu9LA7gMeta } from "/opt/buildhome/repo/pages/sluzby.vue?macro=true";
import { default as termsjw1825O2ZdMeta } from "/opt/buildhome/repo/pages/terms.vue?macro=true";
import { default as zizkovNpCVnoqkwdMeta } from "/opt/buildhome/repo/pages/zizkov.vue?macro=true";
export default [
  {
    name: "complaints___cs",
    path: "/reklamacni-podminky",
    component: () => import("/opt/buildhome/repo/pages/complaints.vue")
  },
  {
    name: "complaints___en",
    path: "/en/complaints-and-returns",
    component: () => import("/opt/buildhome/repo/pages/complaints.vue")
  },
  {
    name: "delivery-payment___cs",
    path: "/dodaci-a-platebni-podminky",
    component: () => import("/opt/buildhome/repo/pages/delivery-payment.vue")
  },
  {
    name: "delivery-payment___en",
    path: "/en/delivery-and-payment",
    component: () => import("/opt/buildhome/repo/pages/delivery-payment.vue")
  },
  {
    name: "gdpr___cs",
    path: "/gdpr",
    component: () => import("/opt/buildhome/repo/pages/gdpr.vue")
  },
  {
    name: "gdpr___en",
    path: "/en/gdpr",
    component: () => import("/opt/buildhome/repo/pages/gdpr.vue")
  },
  {
    name: "gift-cards-cs___cs",
    path: "/gift-cards/cs",
    component: () => import("/opt/buildhome/repo/pages/gift-cards/cs/index.vue")
  },
  {
    name: "gift-cards-cs___en",
    path: "/en/gift-cards/cs",
    component: () => import("/opt/buildhome/repo/pages/gift-cards/cs/index.vue")
  },
  {
    name: "gift-cards-cs-return___cs",
    path: "/gift-cards/cs/return",
    component: () => import("/opt/buildhome/repo/pages/gift-cards/cs/return.vue")
  },
  {
    name: "gift-cards-cs-return___en",
    path: "/en/gift-cards/cs/return",
    component: () => import("/opt/buildhome/repo/pages/gift-cards/cs/return.vue")
  },
  {
    name: "gift-cards-en___cs",
    path: "/gift-cards/en",
    component: () => import("/opt/buildhome/repo/pages/gift-cards/en/index.vue")
  },
  {
    name: "gift-cards-en___en",
    path: "/en/gift-cards/en",
    component: () => import("/opt/buildhome/repo/pages/gift-cards/en/index.vue")
  },
  {
    name: "gift-cards-en-return___cs",
    path: "/gift-cards/en/return",
    component: () => import("/opt/buildhome/repo/pages/gift-cards/en/return.vue")
  },
  {
    name: "gift-cards-en-return___en",
    path: "/en/gift-cards/en/return",
    component: () => import("/opt/buildhome/repo/pages/gift-cards/en/return.vue")
  },
  {
    name: "index___cs",
    path: "/",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "maintenance___cs",
    path: "/maintenance",
    meta: maintenancefe5TKEsKxKMeta || {},
    component: () => import("/opt/buildhome/repo/pages/maintenance.vue")
  },
  {
    name: "maintenance___en",
    path: "/en/maintenance",
    meta: maintenancefe5TKEsKxKMeta || {},
    component: () => import("/opt/buildhome/repo/pages/maintenance.vue")
  },
  {
    name: "nusle___cs",
    path: "/nusle",
    component: () => import("/opt/buildhome/repo/pages/nusle.vue")
  },
  {
    name: "nusle___en",
    path: "/en/nusle",
    component: () => import("/opt/buildhome/repo/pages/nusle.vue")
  },
  {
    name: "sluzby___cs",
    path: "/sluzby",
    component: () => import("/opt/buildhome/repo/pages/sluzby.vue")
  },
  {
    name: "sluzby___en",
    path: "/en/services",
    component: () => import("/opt/buildhome/repo/pages/sluzby.vue")
  },
  {
    name: "terms___cs",
    path: "/obchodni-podminky",
    component: () => import("/opt/buildhome/repo/pages/terms.vue")
  },
  {
    name: "terms___en",
    path: "/en/terms-and-conditions",
    component: () => import("/opt/buildhome/repo/pages/terms.vue")
  },
  {
    name: "zizkov___cs",
    path: "/zizkov",
    component: () => import("/opt/buildhome/repo/pages/zizkov.vue")
  },
  {
    name: "zizkov___en",
    path: "/en/zizkov",
    component: () => import("/opt/buildhome/repo/pages/zizkov.vue")
  }
]